<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
      isAdmin: false,
    }
  },
  created: async function() {
    const authority = await this.$store.dispatch('auth/getAuthority')
    this.isAdmin = authority.isAdmin;
  },
  destroyed() {
    // NOTE: 各小診断の回答画面に遷移するときは初期化しない
/*
    if (this.$route.name !== 'rough-diag-answer') {
      this.$store.dispatch('diag/init');
    }
*/
  },

}
</script>
